export default __webpack_public_path__ + "static/media/assign.f2c9c518.svg";